import { render, staticRenderFns } from "./Siparis.vue?vue&type=template&id=72482d2a&scoped=true&"
import script from "./Siparis.vue?vue&type=script&lang=js&"
export * from "./Siparis.vue?vue&type=script&lang=js&"
import style0 from "./Siparis.vue?vue&type=style&index=0&id=72482d2a&lang=scss&scoped=true&"
import style1 from "./Siparis.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72482d2a",
  null
  
)

export default component.exports